import React from "react";
import { Redirect, RouteComponentProps } from "react-router";

interface PropsSubmissionForm extends RouteComponentProps {
  match: {
    isExact: boolean;
    params: {
      extensionUuid: string;
      token: string;
    };
    path: string;
    url: string;
  };
}

function RecruitmentFormRedirect(props: PropsSubmissionForm) {
  return (
    <Redirect
      to={`/workspace/submission-form/${props.match.params.extensionUuid}/${props.match.params.token}`}
    />
  );
}

export default RecruitmentFormRedirect;
